import React, { useState } from "react";
import { createMuiTheme, ThemeProvider, makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { FormattedMessage } from "react-intl";
import HeaderLogin from "../../components/HeaderLogin";
import clsx from "clsx";
import { FormControl, InputLabel, OutlinedInput, Typography, IconButton, InputAdornment, Button, Drawer, CircularProgress } from "@material-ui/core";
import { Dialog, DialogContent, DialogActions } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
// import svgGoogle from "../../static/Íconos/Google.svg";
// import svgFacebook from "../../static/Íconos/facebook.svg";
import ModalMensajes from "../../components/ModalMensajes";
import svgX from "../../static/Íconos/X.svg";
import { SERVER_URL } from "../../config/backend";
import { Notificaciones } from "../../request/request_home";

const useStyles = makeStyles((theme) => ({
    gridItem: {
        padding: "0px",
        margin: "0px",
    },
    paperContainer: {
        width: "100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover",
    },
    imageSize2160: {
        backgroundImage: `url(${require("../../static/Imágenes/InicioSesion/webp/Background.webp")})`,
    },
    FormControl: {
        marginTop: "2rem",
        width: "70%",
    },
    itemsFormControlRight: {
        textAlign: "right",
    },
    itemsFormControlLeft: {
        textAlign: "left",
    },
    select: {
        width: "70%",
    },
    inputLabel: {
        color: theme.palette.secondary.light,
    },
    colorText: {
        color: theme.palette.secondary.dark,
        fontSize: "16px",
        fontFamily: "Verdana Italic",
    },
    buttonLogin: {
        backgroundColor: theme.palette.secondary.light,
        width: "200px",
        ":hover": {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    lineaHR: {
        color: theme.palette.secondary.dark,
        width: "8vw",
        border: "solid 1.5px",
        borderColor: theme.palette.secondary.dark,
    },
    lineaHRModal: {
        color: theme.palette.secondary.dark,
        width: "8vw",
        marginTop: 20,
        marginBottom: 20,
        borderStyle: "solid",
        border: "3px",
    },
    buttons: {
        borderColor: theme.palette.primary.main,
        ":hover": {
            backgroundColor: theme.palette.secondary.light,
        },
        border: "solid 2.5px",
    },
    DialogGreen: {
        backgroundColor: theme.palette.primary.main,
    },
    FormControlModal: {
        marginTop: "2rem",
        width: "90%",
        //textAlign:'right'
    },
    textoTitle: {
        fontSize: "24px",
        color: "#929292",
    },
    texto: {
        fontSize: "12px",
        color: "#929292",
        fontFamily: "Verdana Bold",
    },
    drawerPaper: {
        background: "#F3F3F3",
        width: window.screen.width > 600 ? 600 : window.screen.width,
    },
    drawer: {
        flexShrink: 0,
    },
}));

const theme = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: 8,
                height: 50,
                color: "#262626",
                fontSize: "16px",
                fontFamily: "Verdana",
                "&:hover $notchedOutline": {
                    borderColor: "#929292",
                    border: "2px solid",
                },
                // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#A68A30",
                    border: "2px solid",
                },
            },
        },
        MuiInputLabel: {
            root: {
                color: "#262626",
                fontSize: "14px",
                fontFamily: "Verdana",
            },
        },
    },
    palette: {
        primary: {
            main: "#182C20",
            dark: "#262626",
            light: "#565656",
            contrastText: "#929292",
        },
        secondary: {
            main: "#F7D00E",
            dark: "#A68A30",
            light: "#DFDFDF",
            contrastText: "#F3F3F3",
        },
    },
});

const themeModal = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                borderRadius: 8,
                height: 50,
                color: "#929292",
                "&:hover $notchedOutline": {
                    borderColor: "#929292",
                    border: "2px solid",
                },
                // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#F3F3F3",
                    border: "2px solid",
                },
            },
            notchedOutline: {
                borderColor: "#929292",
                border: "2px solid",
            },
        },
        MuiInputLabel: {
            root: {
                color: "#DFDFDF",
            },
        },
    },
});

export default function Login(props) {
    const dispatch = useDispatch();
    const selector = useSelector((store) => store);
    const classes = useStyles();
    const { setGlobalNotificaciones } = props;

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const globalLang = useSelector((store) => (store.user.lang === undefined ? "es" : store.user.lang));
    const [correo, setCorreo] = useState("");
    const [contrasenna, setContrasenna] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [openModalOlvidarPass, setOpenModalOlvidarPass] = useState(false);
    const [correoOlvidar, setCorreoOlvidar] = useState("");
    const [loading, setLoading] = useState(false);
    const [openModalMensajes, setOpenModalMensajes] = useState(false);
    const [cuerpoModalMensajes, setCuerpoModalMensajes] = useState({
        tituloModal: "informacion",
        textoModal: "",
    });
    var imageSize = classes.imageSize2160;

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------
    const onChangeCorreo = (e) => {
        setCorreo(e.target.value);
    };

    const onChangeContrasenna = (e) => {
        setContrasenna(e.target.value);
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const onClickIniciarSesion = async () => {
        if (correo === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_login_uno" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        if (contrasenna === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_login_dos" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        var login = `mutation Login($email: String!, $password: String!, $fcmId: String!) {
                login(email: $email, password: $password, fcmId: $fcmId) {
                    response {
                        accessToken
                        expiresIn
                        tokenType
                        refreshToken,
                    }
                    errors {
                        field
                        messages
                        __typename
                    }
                    status
                }
            }`;

        setLoading(true);
        await fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "Login",
                query: login,
                variables: {
                    email: correo,
                    password: contrasenna,
                    fcmId: ""
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data["data"]["login"]["status"] !== 200) {
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: data["data"]["login"]["errors"][0]["messages"][0],
                    });
                    setOpenModalMensajes(true);
                    setCorreo("");
                    setContrasenna("");
                    dispatch({ type: "LOGIN_USER", accessToken: "", username: "" });
                } else {
                    let token = data["data"]["login"]["response"]["accessToken"];
                    dispatch({ type: "LOGIN_USER", accessToken: token, username: correo });
                    dispatch({ type: "DRAWER_OPERATION_LOGIN", status: false });
                    setCorreo("");
                    setContrasenna("");
                    Notificaciones(globalLang, token).then((item) => {
                        setGlobalNotificaciones(item);
                    });
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onClickOlvidarPass = () => {
        setOpenModalOlvidarPass(true);
    };

    const onClickRegistrarse = () => {
        dispatch({ type: "DRAWER_OPERATION_LOGIN", status: false });
        dispatch({ type: "DRAWER_OPERATION_REGISTER", status: true });
    };

    const handleClickCloseModalOlvidarPass = () => {
        setOpenModalOlvidarPass(false);
    };

    const handleClickButtonEnviar = () => {
        if (correoOlvidar === "") {
            setCuerpoModalMensajes({
                ...cuerpoModalMensajes,
                tituloModal: "informacion",
                textoModal: <FormattedMessage id="validacion_login_uno" />,
            });
            setOpenModalMensajes(true);
            return;
        }
        var Forgotpassword = `mutation Forgotpassword($email: String!) {
            forgotPassword(email: $email) {
                errors {
                    field
                    messages
                }
                status
            }
        }`;

        setLoading(true);
        fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
                language: globalLang,
            },
            body: JSON.stringify({
                operationName: "Forgotpassword",
                query: Forgotpassword,
                variables: {
                    email: correoOlvidar,
                },
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                setLoading(false);
                if (data["data"]["forgotPassword"]["status"] !== 200) {
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: data["data"]["forgotPassword"]["errors"][0]["messages"][0],
                    });
                    setOpenModalMensajes(true);
                    setCorreoOlvidar("");
                } else {
                    setCuerpoModalMensajes({
                        ...cuerpoModalMensajes,
                        tituloModal: "informacion",
                        textoModal: <FormattedMessage id="validacion_login_tres" />,
                    });
                    setOpenModalMensajes(true);
                    setCorreoOlvidar("");
                    setOpenModalOlvidarPass(false);
                }
            });
    };

    const onChangeCorreoOlvidar = (e) => {
        setCorreoOlvidar(e.target.value);
    };

    const handleClickClose = () => {
        dispatch({ type: "DRAWER_OPERATION_LOGIN", status: false });
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Drawer
                    className={classes.drawer}
                    variant="temporary"
                    anchor="right"
                    open={selector.user.open_drawer_login}
                    classes={{
                        paper: classes.drawerPaper,
                    }}
                    onEscapeKeyDown={handleClickClose}
                    onBackdropClick={handleClickClose}
                >
                    <Grid container spacing={0}>
                        <Grid item xs={12} sm={12} md={12} className={classes.gridItem}>
                            <div className={clsx(imageSize, classes.paperContainer)}>
                                <HeaderLogin namePage={<FormattedMessage id="inicio_sesion" />} />
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} className={classes.gridItem}>
                            <Grid container style={{ textAlign: "center" }}>
                                <Grid item xs={12} className={classes.itemsFormControl}>
                                    <FormControl variant="outlined" className={classes.FormControl}>
                                        <InputLabel htmlFor="correoElectronico" required>
                                            <FormattedMessage id="correo" />
                                        </InputLabel>
                                        <OutlinedInput
                                            id="correoElectronico"
                                            label={<FormattedMessage id="correo" />}
                                            value={correo}
                                            placeholder=""
                                            onChange={(e) => onChangeCorreo(e)}
                                            //label={<FormattedMessage id="correo" />}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} className={classes.itemsFormControl}>
                                    <FormControl className={classes.FormControl} variant="outlined">
                                        <InputLabel htmlFor="contrasenna" required>
                                            {<FormattedMessage id="pass" />}
                                        </InputLabel>
                                        <OutlinedInput
                                            id="contrasenna"
                                            type={showPassword ? "text" : "password"}
                                            value={contrasenna}
                                            onChange={(e) => onChangeContrasenna(e)}
                                            placeholder=""
                                            label={<FormattedMessage id="pass" />}
                                            endAdornment={
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end">
                                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                                    </IconButton>
                                                </InputAdornment>
                                            }
                                            labelWidth={80}
                                        />
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} style={{ textAlign: "center", marginTop: "2rem" }}>
                                    <Button variant="text" className={classes.colorText} onClick={onClickOlvidarPass}>
                                        <FormattedMessage id="olvidar_pass" />
                                    </Button>
                                </Grid>

                                <Grid item xs={12} style={{ marginTop: "2rem" }}>
                                    <Button size="large" className={classes.buttonLogin} onClick={onClickIniciarSesion}>
                                        <FormattedMessage id="iniciar_session" />
                                    </Button>
                                </Grid>

                                {loading && (
                                    <Grid item xs={12} style={{ marginTop: "1rem" }}>
                                        <CircularProgress disableShrink color="primary" size={30} />
                                    </Grid>
                                )}

                                {/* <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "2rem",
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <hr className={classes.lineaHR} style={{ marginRight: 5 }} />
                                    <Typography style={{ fontSize: "16px", fontFamily: "Verdana", color: "#262626" }}>
                                        <FormattedMessage id="inicia_sesion_con" />
                                    </Typography>
                                    <hr className={classes.lineaHR} style={{ marginLeft: 5 }} />
                                </Grid> */}

                                {/* <Grid item xs={12} style={{ marginTop: "2rem" }}>
                                    <Button
                                        variant="outlined"
                                        className={classes.buttons}
                                        onClick={() => {}}
                                        style={{ marginRight: "1rem" }}
                                    >
                                        <img alt="Google" style={{ height: "40px", width: "80px" }} src={svgGoogle} />
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        className={classes.buttons}
                                        onClick={() => {}}
                                    >
                                        <img alt="Facebook" style={{ height: "40px", width: "80px" }} src={svgFacebook} />
                                    </Button>
                                </Grid> */}

                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        marginTop: "1rem",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Typography style={{ fontSize: "16px", fontFamily: "Verdana Italic", color: "#929292" }}>
                                            <FormattedMessage id="no_tienes_cuenta" />
                                        </Typography>

                                        <Button
                                            variant="text"
                                            onClick={onClickRegistrarse}
                                            style={{
                                                textTransform: "unset",
                                                fontSize: "16px",
                                                fontFamily: "Verdana Bold Italic",
                                                color: "#A68A30",
                                            }}
                                        >
                                            <FormattedMessage id="registrate" />
                                        </Button>
                                    </div>
                                </Grid>

                                <Grid container item xs={12} style={{ backgroundColor: "#182C20", height: 30, marginTop: 50 }} />
                            </Grid>
                        </Grid>
                    </Grid>
                </Drawer>
            </ThemeProvider>
            <ThemeProvider theme={themeModal}>
                <Dialog
                    maxWidth="xs"
                    open={openModalOlvidarPass}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleClickCloseModalOlvidarPass();
                        }
                    }}
                    disableEscapeKeyDown={true}
                    aria-labelledby="max-width-dialog-title"
                    fullWidth
                >
                    <DialogContent className={classes.DialogGreen}>
                        <div style={{ display: "flex" }}>
                            <div className={classes.textoTitle} style={{ marginLeft: 70 }}>
                                <FormattedMessage id="olvidar_pass" />
                            </div>
                            <img alt="X" src={svgX} className={classes.imageIconX} style={{ marginLeft: 60 }} onClick={handleClickCloseModalOlvidarPass} />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <hr className={classes.lineaHRModal} />
                            <Typography className={classes.texto}>
                                <FormattedMessage id="olvidar_pass_text" />
                            </Typography>

                            <FormControl className={classes.FormControlModal} variant="outlined">
                                <InputLabel htmlFor="correoElectronico" required>
                                    <FormattedMessage id="correo" />
                                </InputLabel>
                                <OutlinedInput id="correoElectronico" label={<FormattedMessage id="correo" />} value={correoOlvidar} placeholder="" onChange={(e) => onChangeCorreoOlvidar(e)} />
                            </FormControl>
                        </div>
                    </DialogContent>
                    <DialogActions className={classes.DialogGreen} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Button variant="contained" onClick={handleClickButtonEnviar} className={classes.button} style={{ marginTop: 20, marginBottom: 20, width: 120 }}>
                            <FormattedMessage id="olvidar_pass_boton" />
                        </Button>
                    </DialogActions>
                </Dialog>
            </ThemeProvider>
            {/* Dialogo Mensaje */}
            <ModalMensajes openModal={openModalMensajes} setOpenModal={setOpenModalMensajes} cuerpoModal={cuerpoModalMensajes} />
        </div>
    );
}
